import(/* webpackMode: "eager" */ "/schnitt/app/globals.css");
import(/* webpackMode: "eager" */ "/schnitt/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/schnitt/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/schnitt/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/schnitt/components/ui/tooltip.tsx")